import { createSelector } from 'reselect';
// import formatFacility from '../../utils/store/formatFacility';

export const getNearbyFacilities = createSelector(
	(state) =>
		state.pages?.content?.nearbyFacilities ||
		state.app?.nearbyFacilities ||
		{},
	(nearbyFacilities) => {
		if (
			!nearbyFacilities.facilityCollection ||
			!nearbyFacilities.facilityCollection.collection
		) {
			return null;
		}
		const formatedNearbyFacilities =
			nearbyFacilities?.facilityCollection?.collection.map((facility) =>
				facility?.collection ? facility.collection : facility,
			);
		nearbyFacilities.facilityCollection.collection =
			formatedNearbyFacilities || [];

		return nearbyFacilities;
	},
);

export const getNearbyCities = createSelector(
	// Check both pages.content (for backward compatibility) and app state (for global availability)
	(state) =>
		state.pages?.content?.nearbyCities || state.app?.nearbyCities || [],
	(nearbyCities) => {
		return nearbyCities || [];
	},
);
